module.exports = __webpack_public_path__ + "img/DealerIcons-LinkedIn-On.1806a06.jpg";